import vue from 'vue';
import { default as Component } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import Quiz from '../../../interfaces/Quiz';

@Component({
  template: require('./quiz-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
  props: {
    id: [Number, String],
  },
  filters: {
    addSpace(value: any, selected: any) {
      if (selected) {
        // return value.replace("@", '<b>' + selected + '</b>');
        return value.replace("@", selected);
      }
      return value.replace(/@/g, "________________");
    }
  }
})
export class QuizPage extends vue {
  id;

  quizData = {
    id: Number,
    content: [],
    title: String,
  };

  curentQuestion = -1;
  warning = false;

  checkedTrueFalse = null;
  checkedSingle = null;
  checkedFillInBlank = [];

  quizProvider = IocContainer.get < Quiz > (SERVICES.QUIZ);

  @Watch('id')
  onPageReload(val: string) {
    this.loadData();
  }

  // Preloader
  get loading() {
    return this.loadingUser && this.loadingLesson;
  }

  get loadingUser() {
    return this.$store.state.loadingUser;
  }

  get loadingLesson() {
    return this.quizData.title.length > 1 && this.lessonsData.length > -1;;
  }
  // Expiration
  get expired() {
    if (new Date(this.$store.state.user.expiration.replace(/ /g,"T")) > new Date()){
      return false;
    }
    else{
      if (this.userProgress.length > 0 && this.lessonsData.length > 0){
        if (this.userProgress[this.userProgress.length - 1].type == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].type){
          return this.userProgress[this.userProgress.length - 1].id != this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id;
        }
      }
      return true;
    }
  }
  // Data
  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userProgress() {
    return this.$store.state.progress;
  }

  get quizFillInBlankVariants() {
    let variants = [];
    if (this.quizData.content[0].type === 'fill-in-blank') {
      this.quizData.content.forEach((question) => {
        if (Array.isArray(question.result)) {
          question.result.forEach((result) => {
            if (result) {
              variants.push(result);
            }
          });
        }
        if (Array.isArray(question.variants)) {
          question.variants.forEach((variant) => {
            if (variant) {
              variants.push(variant);
            }
          });
        }
      });
    }

    return this.shuffle(variants);
  }

  // DataIndexes
  get quizIndex() {
    return this.lessonsData.indexOf(this.lessonsData.find((lesson) => {
      return lesson.id === this.quizData.id && lesson.type === 'App\\Models\\Quiz';
    }));
  }

  // Logic
  get progressIndex() {
    return this.userProgress.indexOf(this.userProgress.find((lesson) => {
      return lesson.id === this.quizData.id && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
    }));
  }

  get passPrevious() {
    if (this.quizIndex === 0) {
      return true;
    }
    if (this.quizIndex >= 1) {
      const pastLesson = (typeof this.lessonsData[this.quizIndex - 1] !== undefined) ? this.lessonsData[this.quizIndex - 1] : false;

      if (pastLesson) {
        return this.userProgress.indexOf(this.userProgress.find((lesson) => {
          return lesson.id === pastLesson.id && lesson.type === pastLesson.type && lesson.reset != true;
        })) > -1;
      }

      return false;
    }
  }

  get wasThere() {
    if (this.curentQuestion == this.quizData.content.length) {
      return true;
    }
    if (this.lessonsData[this.quizIndex]) {
      return this.lessonsData[this.quizIndex].pass;
    }
  }

  get showResults() {
    window.scroll(0, 0);
    return (this.curentQuestion >= this.quizData.content.length);
  }

  // Buttons
  get previousButtonIndex() {
    if (this.quizIndex > 0 && this.quizIndex <= this.lessonsData.length - 1) {
      return this.quizIndex - 1;
    }
    return false;
  }

  get previousButtonDisplay() {
    return (this.quizIndex > 0 && this.quizIndex <= this.lessonsData.length - 1) ? true : false;
  }

  get nextButtonIndex() {
    if (this.quizIndex >= 0 && this.quizIndex < this.lessonsData.length - 1) {
      return this.quizIndex + 1;
    }
    return false;
  }

  get nextButtonDisplay() {
    return (this.quizIndex >= 0 && this.quizIndex < this.lessonsData.length - 1) ? true : false;
  }

  // Functions
  mounted() {
    this.loadData();

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'SET_COURSE') {
        this.setCurentQuestion();
      }
    })
  }

  loadData() {
    this.quizProvider.getQuiz(this.id).then(
      (response) => {
        this.quizData = response.data;
        this.setCurentQuestion();
      },
      (error) => {
        if (error){
          console.error(error);
        }
        //need to double check this;
        location.reload();
      },
    );
  }

  setCurentQuestion() {
    if (this.progressIndex === -1) {
      this.curentQuestion = 0;
    }
    if (this.progressIndex >= 0) {
      this.curentQuestion = this.$store.state.progress[this.progressIndex].answers.length;
      if (this.curentQuestion >= this.quizData.content.length && !this.$store.state.progress[this.progressIndex].result){
        this.curentQuestion = this.$store.state.progress[this.progressIndex].answers.length - 1;
      }
    }
  }

  calcVariantsLabel(question, question_index, variant) {
    if (this.checkQuestionResult(question, question_index)) {
      if (question.result.length <= 1){
        if (variant === question.result) {
          return 'correct';
        } else {
          return '';
        }
      } else {
        if (variant === question.result) {
          // console.log(variant === question.result);
          return 'correct';
        } else {
          if (variant === this.userProgress[this.progressIndex].answers[question_index]) {
            return 'wrong';
          } 
          else {
            return '';
          }
        }
      }
    }
    else {
      if (variant === question.result) {
        return 'correct';
      } else {
        if (variant === this.userProgress[this.progressIndex].answers[question_index]) {
          return 'wrong';
        } 
        else {
          return '';
        }
      }
    }
  }

  calccorrectWrongClass(question, question_index) {
    if (this.checkQuestionResult(question, question_index)) {
      return 'correct';
    } else {
      return 'wrong';
    }
  }

  checkQuestionResult(question, question_index) {
    if (this.quizData.content[0].type !== 'fill-in-blank'){
      return question.result == this.userProgress[this.progressIndex].answers[question_index];
    }
    else{
      if (question.result.length <= 1){
        return question.result == this.userProgress[this.progressIndex].answers[question_index];
      }
      if (question.result.length >= 2){
          if (question.result[0] == this.userProgress[this.progressIndex].answers[question_index][0]){
            if (question.result[1] == this.userProgress[this.progressIndex].answers[question_index][1]){
              return true;
            };
            return false;
          }
          return false;
      }
    }
  }

  checkResult() {
    let count = 0;
    let corect = 0;

    this.quizData.content.forEach((question, question_index) => {
      if (this.checkQuestionResult(question, question_index)) {
        ++corect;
        ++count;
      } else {
        ++count;
      }
    });

    return corect + '/' + count;
  }

  countPercentage() {
    let count = 0;
    let corect = 0;

    this.quizData.content.forEach((question, question_index) => {
      if (this.checkQuestionResult(question, question_index)) {
        ++corect;
        ++count;
      } else {
        ++count;
      }
    });

    return Math.round((corect / count) * 100);
  }

  checkedFillInBlankSet(variant) {
    if (this.quizData.content[this.curentQuestion].result.length <= 1){
      
      this.checkedFillInBlank = variant;
    }
    if (this.quizData.content[this.curentQuestion].result.length > 1){
      if (this.checkedFillInBlank.length >= 2){
        this.checkedFillInBlank.length = 0;
        this.checkedFillInBlank.push(variant);
      }
      else{
        this.checkedFillInBlank.push(variant);
      }
    }
  }
  
  

  checkedFillInBlankClass(variant) {
    let classes = [];
    if (this.quizData.content[0].type === 'fill-in-blank') {
      if (this.quizData.content[this.curentQuestion].result.length <= 1){
        if (this.checkedFillInBlank == variant) {
          classes.push('answer');
        }
        if (this.progressIndex > -1) {
          if (this.userProgress[this.progressIndex].answers[this.curentQuestion] == variant) {
            classes.push('answer-selected');
          }
          if (this.userProgress[this.progressIndex].answers.indexOf(variant) > -1) {
            classes.push('answer-was-selected');
          }
        }
      }
      if (this.quizData.content[this.curentQuestion].result.length > 1){
        if (this.checkedFillInBlank){
          if (this.checkedFillInBlank.includes(variant)) {
              classes.push('answer');
            }
            if (this.progressIndex > -1) {
              if (this.userProgress[this.progressIndex].answers[this.curentQuestion]){
                if (this.userProgress[this.progressIndex].answers[this.curentQuestion].length > 0) {
                  this.userProgress[this.progressIndex].answers[this.curentQuestion].forEach(answer => {
                    if (answer.includes(variant)){
                      classes.push('answer-selected');
                    }
                  })
                }
              }
            }
        }
      }
      if (this.userProgress[this.progressIndex]){
        this.userProgress[this.progressIndex].answers.forEach(answer => {
          if (answer.includes(variant)){
            classes.push('answer-was-selected');
          }
        });
      }
      // if (this.progressIndex > -1) {
      //   if (this.userProgress[this.progressIndex].answers[this.curentQuestion] == variant) {
      //     classes.push('answer-selected');
      //   }
      //   if (this.userProgress[this.progressIndex].answers.indexOf(variant) > -1) {
      //     classes.push('answer-was-selected');
      //   }
      // }
    }
    return classes;
  }

  prevQuestion() {
    window.scroll(0, 0);
    this.warning = false;
    const data = { ...this.lessonsData[this.quizIndex] };
    data.answers = this.userProgress[this.progressIndex].answers;
    // if (this.progressIndex > -1) {
    //   data.answers = this.userProgress[this.progressIndex].answers;
    // } else {
    //   data.answers = [];
    // }
    if (this.curentQuestion > 0) {
      --this.curentQuestion;
    }

    if (this.userProgress[this.progressIndex].answers[this.curentQuestion]) {
      switch (this.quizData.content[this.curentQuestion].type) {
        case 'true-false':
          if (this.checkedTrueFalse){
            data.answers[this.curentQuestion + 1] = this.checkedTrueFalse;         
          }
          this.checkedTrueFalse = this.userProgress[this.progressIndex].answers[this.curentQuestion];
          break;

        case 'single':
          if (this.checkedSingle){
            data.answers[this.curentQuestion + 1] = this.checkedSingle;           
          }
          this.checkedSingle = this.userProgress[this.progressIndex].answers[this.curentQuestion];
          break;

        case 'fill-in-blank':
          //removing answers on fill-in-blank previous answer
          this.userProgress[this.progressIndex].answers.splice([this.curentQuestion + 1], 1);
          this.checkedFillInBlank = this.userProgress[this.progressIndex].answers[this.curentQuestion];
          break;
      }
    }
    // this.$store.dispatch('saveLessonProgress', data);
  }

  nextQuestion() {
    const data = { ...this.lessonsData[this.quizIndex] };
    window.scroll(0, 0);
    // Record prev progress
    if (this.progressIndex > -1) {
      data.answers = this.userProgress[this.progressIndex].answers;
    } else {
      data.answers = [];
    }

    switch (this.quizData.content[this.curentQuestion].type) {
      case 'true-false':
        if (this.checkedTrueFalse) {
          this.warning = false;
          data.answers[this.curentQuestion] = this.checkedTrueFalse;
          if (this.userProgress[this.progressIndex]) {
            if (this.userProgress[this.progressIndex].answers[this.curentQuestion + 1]) {
              this.checkedTrueFalse = this.userProgress[this.progressIndex].answers[this.curentQuestion + 1];
            } else {
              this.checkedTrueFalse = null;
            }
          } else {
            this.checkedTrueFalse = null;
          }
        } else {
          this.warning = true;
          return this.curentQuestion;
        }
        break;

      case 'single':
        if (this.checkedSingle !== null) {
          this.warning = false;
          data.answers[this.curentQuestion] = this.checkedSingle;
          if (this.userProgress[this.progressIndex]) {
            if (this.userProgress[this.progressIndex].answers[this.curentQuestion + 1]) {
              this.checkedSingle = this.userProgress[this.progressIndex].answers[this.curentQuestion + 1];
            } else {
              this.checkedSingle = null;
            }
          } else {
            this.checkedSingle = null;
          }
        } else {
          this.warning = true;
          return this.curentQuestion;
        }
        break;

      case 'fill-in-blank':
        if (this.checkedFillInBlank !== undefined && this.checkedFillInBlank.length > 0){
          this.warning = false;
          data.answers[this.curentQuestion] = this.checkedFillInBlank;
          if (this.quizData.content[this.curentQuestion].result.length > 1 && this.checkedFillInBlank[1] == undefined){
              this.warning = true;
              return this.curentQuestion;
          }
            if (this.userProgress[this.progressIndex]) {
                if (this.userProgress[this.progressIndex].answers[this.curentQuestion + 1]) {
                  if (this.quizData.content[this.curentQuestion].result.length > 1){
                    if (this.checkedFillInBlank[1] == undefined){
                      this.warning = true;
                      return this.curentQuestion;
                    }
                    else{
                      this.checkedFillInBlank = this.userProgress[this.progressIndex].answers[this.curentQuestion + 1];
                    }                   
                  }
                  else{
                    this.checkedFillInBlank = this.userProgress[this.progressIndex].answers[this.curentQuestion + 1];
                  }
                } else {
                  this.checkedFillInBlank = [];
                }
            } else {
              this.checkedFillInBlank = [];
            }
        } else {
          this.warning = true;
          return this.curentQuestion;
        }
        break;
    }

    if (data.answers.length == this.quizData.content.length) {
      data.resultPercentage = this.countPercentage();
      data.result = this.checkResult().split('/');
    }

    if (this.curentQuestion < this.quizData.content.length) {
      ++this.curentQuestion;
    }
    this.$store.dispatch('saveLessonProgress', data);
  }

  isLesson(buttonIndex) {
    if (this.lessonsData[buttonIndex]) {
      return (this.lessonsData[buttonIndex].type === 'App\\Models\\Lesson') ? true : false;
    }
  }

  isQuiz(buttonIndex) {
    if (this.lessonsData[buttonIndex]) {
      return (this.lessonsData[buttonIndex].type === 'App\\Models\\Quiz') ? true : false;
    }
  }

  addSpace(value: any) {
    if (value.indexOf("@") !== value.lastIndexOf("@")){
      if (this.checkedFillInBlank) {
        const index1 = value.indexOf("@");
        const index2 = value.lastIndexOf("@");
        if (this.checkedFillInBlank[0]){
          if (this.checkedFillInBlank[1]){
            return [value.slice(0, index1), '<span class="fnb-question-answer">' + this.checkedFillInBlank[0] + '</span>', value.slice(index1 + 1, index2), '<span class="fnb-question-answer">' + this.checkedFillInBlank[1] + '</span>', value.slice(index2 + 1)].join('');
          }
          return [value.slice(0, index1), '<span class="fnb-question-answer">' + this.checkedFillInBlank[0] + '</span>', value.slice(index1 + 1, index2), "________________", value.slice(index2 + 1)].join('');
        }
        return value.replace(/@/g, "________________");
      }
      return value.replace(/@/g, "________________");
    }
    else{
      if (this.checkedFillInBlank.length > 0) {
        return value.replace("@", '<span class="fnb-question-answer">' + this.checkedFillInBlank + '</span>');
      }
      return value.replace(/@/g, "________________");
    }
  }

  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  get finalScore() {
      if (this.curentQuestion >= this.quizData.content.length){
    //need to calculate only for last unit
        let total = 0;
        let blocksUnits = this.userProgress.filter((lesson) => {
          return lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
        });
        
        blocksUnits.forEach(quiz => {
          total += quiz.resultPercentage;
        });
        return total / blocksUnits.length;
        }
        else 0
      }
    
      get finishedCourse() {
        if (this.finalScore > 0){
          if (this.userProgress.length > -1){
            if (this.finalScore > 65 && this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]]){
              return this.userProgress[this.userProgress.length - 1].id == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id;
            }
          else{
            return false;
            }
          }
        }
        else{
          return false;
        }
    }
    get finishedPage(){
      if (!this.nextButtonDisplay && this.finishedCourse){
        return true;
      }
    }
}